import { render, staticRenderFns } from "./InspectionsSettingsList.vue?vue&type=template&id=7a138cab&"
import script from "./InspectionsSettingsList.vue?vue&type=script&lang=js&"
export * from "./InspectionsSettingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports